import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ExternalLink } from 'lucide-react';
import api from '../lib/api';

export function SlideAnuncios({ local = 'home' }) {
  const [anuncios, setAnuncios] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    api.get(`/anuncios?tipo=slider`).then(res => setAnuncios(res.data)).catch(() => {});
  }, [local]);

  useEffect(() => {
    if (anuncios.length <= 1) return;
    const timer = setInterval(() => setCurrent(c => (c + 1) % anuncios.length), 5000);
    return () => clearInterval(timer);
  }, [anuncios.length]);

  const handleClick = async (anuncio) => {
    try { await api.post(`/anuncios/${anuncio.id}/clique`); } catch {}
    if (anuncio.urlDestino && anuncio.urlDestino !== '#') {
      window.open(anuncio.urlDestino, '_blank', 'noopener');
    }
  };

  if (anuncios.length === 0) return (
    <div className="rounded-sm overflow-hidden bg-[#0F6E56]/30" style={{ aspectRatio: '16/5' }}>
      <div className="w-full h-full flex items-center justify-center">
        <p className="text-white/50 text-sm">Espaço para anunciantes</p>
      </div>
    </div>
  );

  return (
    <div className="relative rounded-sm overflow-hidden shadow-lg" style={{ aspectRatio: '16/5' }} data-testid="slide-anuncios" id="banner-anuncios">
      {anuncios.map((a, i) => (
        <div
          key={a.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
          {a.imagemUrl ? (
            <img
              src={a.imagemUrl}
              alt={a.titulo}
              className="w-full h-full object-cover cursor-pointer"
              onClick={() => handleClick(a)}
            />
          ) : (
            <div
              className="w-full h-full bg-[#0F6E56] flex items-center justify-center cursor-pointer"
              onClick={() => handleClick(a)}
            >
              <p className="text-white font-bold text-2xl">{a.titulo}</p>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
          <div className="absolute bottom-3 left-4 right-10">
            <p className="text-white font-bold text-base drop-shadow">{a.titulo}</p>
            {a.descricao && <p className="text-white/80 text-xs mt-0.5">{a.descricao}</p>}
          </div>
          {a.urlDestino && a.urlDestino !== '#' && (
            <button
              onClick={() => handleClick(a)}
              className="absolute bottom-3 right-3 bg-white/20 hover:bg-white/30 text-white rounded-lg p-1.5 transition-colors"
            >
              <ExternalLink size={14} />
            </button>
          )}
        </div>
      ))}

      {anuncios.length > 1 && (
        <>
          <button
            onClick={() => setCurrent(c => (c - 1 + anuncios.length) % anuncios.length)}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-colors z-10"
            data-testid="slide-prev-btn"
          >
            <ChevronLeft size={18} />
          </button>
          <button
            onClick={() => setCurrent(c => (c + 1) % anuncios.length)}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-1.5 transition-colors z-10"
            data-testid="slide-next-btn"
          >
            <ChevronRight size={18} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
            {anuncios.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`rounded-full transition-all ${i === current ? 'bg-white w-4 h-1.5' : 'bg-white/40 w-1.5 h-1.5'}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
